import { render, staticRenderFns } from "./products.vue?vue&type=template&id=492ddb70&"
import script from "./products.vue?vue&type=script&lang=ts&"
export * from "./products.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports